function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
// eslint-disable-next-line
import isChromatic from 'chromatic/isChromatic';
import { Button } from '../../atoms';
import { MenuToggle as MenuToggleIcon, CloseBold } from '../../visuals';
import { useAccentColors } from '../../hooks';
var fadeInProps = {
    initial: {
        opacity: 0
    },
    exit: {
        opacity: 0
    },
    animate: {
        opacity: 1
    }
};
var transition = isChromatic() ? {
    type: 'just',
    delay: 0
} : {
    type: 'tween',
    duration: 0.1
};
export default function MenuToggle(param) {
    var open = param.open, onClick = param.onClick;
    var accentStyle = useAccentColors([
        'colors-button-secondary-bg-base',
        '--colors-bg-subtle'
    ], [
        'colors-button-secondary-bg-hover',
        '--colors-subtle-700'
    ]);
    return /*#__PURE__*/ React.createElement(Button, {
        "aria-label": "Menu",
        type: "icon-only",
        onClick: onClick,
        style: accentStyle,
        icon: /*#__PURE__*/ React.createElement(AnimatePresence, {
            mode: "wait"
        }, !open && /*#__PURE__*/ React.createElement(motion.div, _object_spread_props(_object_spread({
            key: "toggle",
            transition: transition
        }, fadeInProps), {
            className: "text-fg-base col-start-1 row-start-1"
        }), /*#__PURE__*/ React.createElement(MenuToggleIcon, {
            className: "block w-5 h-auto"
        })), !!open && /*#__PURE__*/ React.createElement(motion.div, _object_spread_props(_object_spread({
            key: "close",
            transition: transition
        }, fadeInProps), {
            className: "text-fg-base col-start-1 row-start-1"
        }), /*#__PURE__*/ React.createElement(CloseBold, {
            key: "close",
            className: "block w-7 h-auto"
        }))),
        variant: "secondary",
        className: "flex items-center justify-center w-[3.75rem] h-[3.75rem]"
    });
}

//# sourceMappingURL=MenuToggle.js.map